__turbopack_context__.v({
  "center_amount": "styles-module-scss-module__N1kurW__center_amount",
  "center_subtitle": "styles-module-scss-module__N1kurW__center_subtitle",
  "chart_container": "styles-module-scss-module__N1kurW__chart_container",
  "chart_wrapper": "styles-module-scss-module__N1kurW__chart_wrapper",
  "condensed": "styles-module-scss-module__N1kurW__condensed",
  "hide_visual": "styles-module-scss-module__N1kurW__hide_visual",
  "legend_amount": "styles-module-scss-module__N1kurW__legend_amount",
  "legend_color": "styles-module-scss-module__N1kurW__legend_color",
  "legend_container": "styles-module-scss-module__N1kurW__legend_container",
  "legend_item": "styles-module-scss-module__N1kurW__legend_item",
  "legend_label": "styles-module-scss-module__N1kurW__legend_label",
  "mobile_total": "styles-module-scss-module__N1kurW__mobile_total",
});
